const siteOptionsParsed = siteOptionsSchema.safeParse(site_options);

export function useSiteOptions() {
  if (!siteOptionsParsed.success) {
    throw new Error("Invalid site options data");
  }
  return { siteOptions: siteOptionsParsed.data };
}
